import { TIME_ENTRY_WORK_FIELDS } from "./fields/time-entry-fields-work";
import { TIME_ENTRY_BILLING_FIELDS } from "./fields/time-entry-fields-billing";
import { TIME_ENTRY_SYNC_FIELDS } from "./fields/time-entry-fields-sync";
import { TIME_ENTRY_SCHEDULE_FIELDS } from "./fields/time-entry-fields-schedule";
import { TIME_ENTRY_PEOPLE_FIELDS } from "./fields/time-entry-fields-people";
import { TIME_ENTRY_METADATA_FIELDS } from "./fields/time-entry-fields-metadata";

/** Time entry field configurations for table and form */
export const TIME_ENTRY_FIELD_CONFIGS = {
  ...TIME_ENTRY_WORK_FIELDS,
  ...TIME_ENTRY_BILLING_FIELDS,
  ...TIME_ENTRY_SYNC_FIELDS,
  ...TIME_ENTRY_SCHEDULE_FIELDS,
  ...TIME_ENTRY_PEOPLE_FIELDS,
  ...TIME_ENTRY_METADATA_FIELDS,
} as const;
